import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { SelectableItem } from "src/services/item/item.interface";
import { NavigationService } from "src/services/navigation/navigation.service";
import { rackToString } from "src/services/item/rack.interface";
import { isValidRack } from "src/services/item/item.utils";
import { itemCategoryToString, itemNameToString } from "src/services/item/item-display";
import { EditingMode } from "../../../../../shared/editing.const";

@Component({
  selector: "rc-item-in-list",
  templateUrl: "./item-in-list.component.html",
  styleUrls: ["./item-in-list.component.scss"],
  standalone: false,
})
export class ItemInListComponent implements OnChanges {
  @Input() public allowSlideToDelete: boolean = false;
  @Input() public selectableItem: SelectableItem;
  @Input() public mode: EditingMode = "read";
  @Input() public showScanButtonIfNeeded: boolean = false;
  @Input() public showStatus: boolean = true;
  @Input() public withItemStatus: boolean;

  @Output() onSelect = new EventEmitter<string>();
  @Output() onDeselect = new EventEmitter<string>();

  public showScanButton: boolean = false;

  constructor(public readonly navigationService: NavigationService) {}

  public ngOnChanges(): void {
    this.showScanButton =
      this.showScanButtonIfNeeded &&
      (this.selectableItem.status === "onboarding" ||
        this.selectableItem.status !== "inStorage" ||
        !isValidRack(this.selectableItem));
  }

  public async onClick(): Promise<void> {
    if (this.mode === "read") {
      await this.navigationService.goToItemDetailsPage(this.selectableItem.id);
    } else if (this.selectableItem.selected) {
      this.onDeselect.emit(this.selectableItem.id);
      this.selectableItem.selected = false;
    } else {
      this.onSelect.emit(this.selectableItem.id);
      this.selectableItem.selected = true;
    }
  }

  public readonly rackToString = rackToString;
  public readonly itemCategoryToString = itemCategoryToString;
  public readonly itemNameToString = itemNameToString;
}
